import { ICONS } from '@/components/icons/icons'

import styles from './ThemeToggle.module.css'
import { useTheme } from './useTheme'

export function ThemeToggle() {
  const { theme, toggle } = useTheme()
  const next = theme === 'dark' ? 'light' : 'dark'
  const Icon = theme === 'dark' ? ICONS.sun : ICONS.moon
  return (
    <button type="button" className={styles.toggle} onClick={toggle} aria-label={`Switch to ${next} theme`}>
      <Icon size={13} />
      {next === 'dark' ? 'Dark' : 'Light'}
    </button>
  )
}
